import { createSlice } from "@reduxjs/toolkit";

const sysSlice = createSlice({
  name: "sys",
  initialState: {
    bizList: [],
    jwt: null,
    showLoading: false,
    openSupport: false,
    changeBizLoading: false,
    deleteMassage: { massage: "", onClick: () => { } },
    showMassage: null,
    wsIsConnected: false,
    isSystem: false
  },
  reducers: {
    setJwt(state, action) {
      state.bizList = action.payload;
    },
    setBizList(state, action) {
      state.bizList = action.payload;
    },
    setShowLoading(state, action) {
      state.showLoading = action.payload;
    },
    setOpenSupport(state, action) {
      state.openSupport = action.payload;
    },
    setChangeBizLoading(state, action) {
      state.changeBizLoading = action.payload;
    },
    setDeleteMassage(state, action) {
      state.deleteMassage = action.payload;
    },
    setValidation(state, action) {
      state.validation = action.payload;
    },
    setShowMassage(state, action) {
      state.showMassage = action.payload;
    },
    setWsIsConnected(state, action) {
      state.wsIsConnected = action.payload;
    },
    setIsSystem(state, action) {
      state.isSystem = action.payload;
    },
  },
});

export const {
  setJwt,
  setShowLoading,
  setOpenSupport,
  setChangeBizLoading,
  setShowMassage,
  setDeleteMassage,
  setBizList,
  setWsIsConnected,
  setIsSystem,
  setValidation,
} = sysSlice.actions;
export default sysSlice.reducer;
